/*
This is a component used on the page.
*/

import * as React from 'react';
import { OptionsViewModel, StatesViewModel } from '@models/common.models';
import { DynamicSelectIdentifier } from '@common/components/dynamic-select/dynamic-select-types';
import { ContractCommentTypesViewModel } from '@models/Contract';

// Defining the properties the component expects
// Consider this the "setup" of the component
// All properties should be readonly
export interface DynamicSelectProps {
  readonly identifier: DynamicSelectIdentifier;
  readonly searchId?: number;
  readonly stateAbbreviation?: string;
  readonly errorMessage?: string;
  readonly options: (OptionsViewModel | StatesViewModel | ContractCommentTypesViewModel)[];
  readonly onChange: () => void;
  readonly whenLoaded: Function;
  readonly name: string;
  readonly value: string;
  readonly disabled: boolean;
  readonly filter?: { prop: string; value: string };
  readonly filterOut?: { prop: string; values: string[] };
  readonly returnValue?: boolean;
  readonly returnOption?: boolean;
  readonly onBlur: () => void;
  readonly onFocus: () => void;
  readonly onKeyPress: () => void;
  readonly loadOptions: () => void;
  readonly clearOptions: () => void;
}

// Component definition
export class DynamicSelectComponent extends React.Component<DynamicSelectProps> {
  componentDidMount() {
    this.props.loadOptions();
  }

  componentWillReceiveProps(newProps: DynamicSelectProps) {
    if (this.props.searchId && this.props.searchId !== newProps.searchId) {
      this.props.loadOptions();
    }
  }

  shouldComponentUpdate(nextProps: DynamicSelectProps, nextState: any) {
    return (
      nextProps.options.length !== this.props.options.length ||
      nextProps.value !== this.props.value ||
      this.props.filter !== nextProps.filter ||
      this.props.disabled !== nextProps.disabled
    );
  }

  renderOptions() {
    if (!this.props || !this.props.options || !this.props.options.length || this.props.options.length === 0) {
      return;
    }

    if (
      this.props.identifier === DynamicSelectIdentifier.USStates ||
      this.props.identifier === DynamicSelectIdentifier.USFacilityStates
    ) {
      return this.props.options.map((option: StatesViewModel, index) => {
        return (
          <option key={index} value={this.props.returnValue ? option.name : option.abbreviation}>
            {option.abbreviation} - {option.name}
          </option>
        );
      });
    }

    if (this.props.identifier === DynamicSelectIdentifier.ContractCommentTypes) {
      return this.props.options.map((option: ContractCommentTypesViewModel, index) => {
        return (
          <option key={index} value={option.contractCommentTypeAn}>
            {option.contractCommentTypeAn} - {option.contractCommentTypeDs}
          </option>
        );
      });
    }

    let options = this.props.options;
    if (this.props.filter) {
      options = this.props.options.filter(option => option[this.props.filter!.prop] === this.props.filter!.value);
    }

    if (this.props.filterOut) {
      options = this.props.options.filter(
        option => this.props.filterOut!.values.indexOf(option[this.props.filterOut!.prop]) === -1
      );
    }

    return options.map((option: OptionsViewModel, index) => {
      return (
        <option
          key={index}
          value={this.props.returnOption ? JSON.stringify(option) : this.props.returnValue ? option.value : option.id}
        >
          {option.value}
        </option>
      );
    });
  }

  render() {
    // NOTE: HAVE TO CHECK FOR VALUES EQUAL TO O AS SOME IDS ARE SET TO 0 IN DATABASE
    return (
      <select
        onChange={this.props.onChange}
        name={this.props.name}
        value={this.props.value ? this.props.value : +this.props.value === 0 ? 0 : -1}
        onBlur={this.props.onBlur}
        onFocus={this.props.onFocus}
        onKeyPress={this.props.onKeyPress}
        disabled={this.props.disabled}
      >
        <option value={-1}>Select one ...</option>
        {this.renderOptions()}
      </select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dynamic-select/_components/dynamic-select.component.tsx